import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { getInitialize } from 'redux/slices/auth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { SnackbarInitializer } from './utils/snackbar';
import FirebaseProvider from './components/FirebaseProvider';
import theme from './theme';

const App = ({ children }) => {
  const anchorOrigin = { horizontal: 'right', vertical: 'top' };

  const dispatch = useDispatch();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnMount: true,
          },
        },
      }),
  );

  useEffect(() => {
    dispatch(getInitialize());
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <FirebaseProvider>
              <SnackbarProvider
                anchorOrigin={anchorOrigin}
                autoHideDuration={3000}
                maxSnack={1}
              >
                <SnackbarInitializer />
                {children}
              </SnackbarProvider>
            </FirebaseProvider>
          </LocalizationProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;
